import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * SkeletonCard — Presentation Component
 *
 * Displays animated placeholder cards while data is loading.
 * Matches the IndexCard layout so content doesn't shift on load.
 */
@Component({
  selector: 'app-skeleton-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton-card.component.html',
  styleUrl: './skeleton-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonCardComponent {
  /** Number of skeleton cards to render (should match pageSize) */
  @Input() count = 9;

  /** Generate an array of indices for iteration */
  get skeletonItems(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
